import React from 'react'
import Section from '../../../../components/section'
import Text from '../../../../components/text'
import Input from '../../../../components/input'
import Button from '../../../../components/button'
import EyeIcon from '../../../../components/svg/EyeIcon'
import useLogin from '../hooks/login.hook'
import {useFormik} from "formik";
import * as Yup from "yup";
import Flex from '../../../../components/flex'
import { NavLink } from 'react-router-dom'

const LoginView = () => {
    const {
        showPassword,
        openForgotPassword,
        showPasswordClick,
        onSubmitLogin
    } = useLogin();
    const formik = useFormik({
        initialValues: {
            uname: '',
            password: '',
        },
        validationSchema: Yup.object({
            uname: Yup.string().required('Please enter a valid email address').email('Please enter a valid email address'),
            password: Yup.string().min(6, 'Please enter a valid password').required('Please enter a valid password'),
        }),
        onSubmit: (values, actions) => {
            const body = {
                email: values.uname,
                password: values.password
            }
            onSubmitLogin(body, actions)
        }
    });
    return (
        <>
            <Section>
                <div className="row">
                    <div className="col-12 col-md-5 mx-auto">
                        <div className="auth-form-wrapper">
                        <Text type="H1" text="Login"  />
                        <form onSubmit={formik.handleSubmit}>
                            <div className="formBox">
                                <Input
                                    // label="Email Address"
                                    type="text"
                                    name="uname"
                                    placeholder="Your Email Address"
                                    autoFocus={true}
                                    value={formik.values.uname}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    mandatory
                                    errormessage={formik.touched.uname && formik.errors.uname ? (
                                        formik.errors.uname
                                    ) : null}
                                />
                            </div>
                            <div className="formBox">
                                <Input
                                    // label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    name="password"
                                    placeholder="********"
                                    value={formik.values.password}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    errormessage={formik.touched.password && formik.errors.password ? (
                                        formik.errors.password
                                    ) : null}
                                    icon={
                                        <span onClick={showPasswordClick}><EyeIcon visible={showPassword} /></span>
                                    }
                                />
                            </div>
                            <Flex justifyContent="end" className="mb-48">
                                <Button
                                    link
                                    text="Forgot Password?"
                                    onClick={openForgotPassword}
                                    type="button"
                                />
                            </Flex>
                            <Flex justifyContent="center" className="mb-48">
                                <Button
                                    type="submit"
                                    text="Login"
                                    large
                                    isSubmitting={formik.isSubmitting}
                                    disabled={formik.isSubmitting}
                                />
                            </Flex>
                        </form>
                        <Flex justifyContent="center" className="my-3">
                            <Text type="SPAN" text="Don't have an account? " />
                            <NavLink to={'/create-account'} className="ml-2"><b>Register Now</b></NavLink>
                        </Flex>
                        </div>
                    </div>
                </div>
            </Section>
        </>
    )
}

export default LoginView